import { useState } from 'react';
import { EVENT_ROLE, EventRoleStatus } from '@type/db-types';
import { CircularProgress, FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { updateEventRole } from '@modules/supabase/events';
import useUser from '@hooks/useUser';

interface Props {
    refresh: () => void;
    user: EventRoleStatus;
}

export default function EventRoleSelector({ refresh, user }: Props) {
    const currentUser = useUser();
    const { membershipId, membershipRole } = user;
    const [loading, setLoading] = useState(false);

    const handleChange = async ({ target: { value: role } }: SelectChangeEvent) => {
        if (!membershipId) return;

        setLoading(true);
        await updateEventRole(role as EVENT_ROLE, membershipId);

        // invalidate local user data & refetch
        refresh();
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    if (!user) return null;

    // Prevent admins from demoting themselves and breaking their setup
    if (currentUser.user?.id === user.id && user.membershipRole === EVENT_ROLE.OWNER)
        return user.membershipRole;

    return (
        <FormControl fullWidth>
            <Select
                id="permission-level-select"
                value={membershipRole || ''}
                onChange={handleChange}
                // padding right to ensure the dropdown arrow does not overlap the text
                SelectDisplayProps={{ style: { padding: '0.5rem', paddingRight: '1.75rem' } }}
            >
                <MenuItem value={EVENT_ROLE.OWNER}>{'Admin'}</MenuItem>
                <MenuItem value={EVENT_ROLE.STAFF}>{'Staff'}</MenuItem>
                {/* <MenuItem value={EVENT_ROLE.VIEWER}>{'Viewer Only'}</MenuItem> */}
            </Select>
        </FormControl>
    );
}
